module.exports = __webpack_public_path__ + "assets/img/help_btn.e0342847.svg";